
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('Navigation', function () {
		
		this.current = undefined;
    this.state = {};
    this.intendedPath = undefined;

    this.setupMenu = function (config) {
      this.current = config;
    };

    this.teardownMenu = function () {
      this.current = undefined;
    };

    this.setCurrentState = function (state) {
      this.state = state;
    }

    this.currentState = {
      getTitle: () => {
        if (this.state.data) {
          return this.state.data.navTitle || this.state.data.title || '';
        } else {
          return '';
        }
      }
    }

    this.setIntendedPath = path => {
      this.intendedPath = path;
    }

    this.getIntendedPath = clear => {
      let path = this.intendedPath;
      if (clear) {
        this.intendedPath = undefined;
      }
      return path;
		}
		
	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/navigation.service.js